export const REGION_LIST_DELIMITER = '|';
export const SINGLE_REGION_DELIMITER = '~';
